import { getOr, tap } from 'lodash/fp';

import shareDesign from '../api/designBuilder/shareDesign';
import loading from './loading';
import loaded from './loaded';
import dismissShareModal from './share/dismissShareModal';
import shareModal from './share/shareModal';
import estimateSharedSuccessfully from './share/estimateSharedSuccessfully';
import globalError from './globalError';
import { SUCCESSFUL_SHARE } from '../components/ShareEstimate/steps/stepTypes';

export default (designIds, customerName, email, message, dcName, dcEmail, dcPhone, dcExtension) =>
  (dispatch) => {
    dispatch(loading());
    dispatch(dismissShareModal());

    return shareDesign(
      designIds,
      customerName,
      email,
      message,
      dcName,
      dcEmail,
      dcPhone,
      dcExtension,
    )
      .then((response) => {
        dispatch(estimateSharedSuccessfully({
          designIds,
          email,
          sharedDate: Date().toString(),
        }));
        dispatch(shareModal(SUCCESSFUL_SHARE));
        return response;
      })
      .then(tap(() => dispatch(loaded())))
      .catch((err) => {
        if (getOr('', 'response.data.Message')(err).includes('This design is already shared with another customer')) {
          dispatch(globalError({ text: 'This estimate has already been shared.', reload: true }));
        } else {
          dispatch(globalError({ err }));
        }
      });
  };
